import { useTranslation } from "react-i18next";
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, message, Modal, Rate } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { useState } from 'react';
import { removeFeedback, replyFeedback } from '../../../../../service/course-management';
import { CourseManagementStore } from '../../../../../stores/stores';
import { ReviewTpe } from '../../../../../types/course-management';
import "./FeedbackModal.scss";
type Props = {
	reviewDetails?: ReviewTpe
	open: boolean
	handleCancel: () => void
	replyType: string
}

const ReplyModal = (props: Props) => {
  const { t } = useTranslation();
	const { reviewDetails, open, handleCancel, replyType } = props;
	const { courseName, reloadFeedback, setReloadFeedback } = CourseManagementStore()
	const [isReply, setIsReply] = useState<boolean>(false)
	const [replyContent, setReplyContent] = useState<string>("")

	const handleReplyFeedback = async () => {
		const payload = {
			commentId: reviewDetails?.id,
			feedback: replyContent
		}
		try {
			await replyFeedback(payload)
			setReloadFeedback(!reloadFeedback)
			message.success(t("Phản hồi đánh giá thành công", "Phản hồi đánh giá thành công"))
			handleCancel()
		} catch (error) {

		}
	}

	const handleRemoveFeedback = async () => {
		try {
			await removeFeedback(Number(reviewDetails?.id))
			message.success(t("Gỡ đánh giá thành công", "Gỡ đánh giá thành công"))
			setReloadFeedback(!reloadFeedback)
			setTimeout(() => {
				handleCancel()
			}, 0);
		} catch (error) {

		}
	}

	return (
		<Modal
			centered
			className='feedback-modal'
			title={t("Đánh giá", "Đánh giá")} open={open} onCancel={handleCancel}
			footer={
				replyType === "feedback" ?
					<div className='flex gap-2'>
						<Button type='primary'
							onClick={handleReplyFeedback}
							disabled={replyContent === ""}
						>{t("Gửi", "Gửi")}</Button>
						<Button onClick={handleCancel}>{t("Đóng", "Đóng")}</Button>
					</div> : null
			}
		>
			<>
				<div className="flex align-center justify-between">
					<div className='flex align-center gap-4 mt-2'>
						<Avatar
							src={reviewDetails?.imagePath}
							icon={<UserOutlined />}
							size={48}
						/>
						<div>
							<p className='text-lg font-weight-5'>{reviewDetails?.username}</p>
							<div className='flex align-center gap-8 description-color'>
								<Rate disabled defaultValue={reviewDetails?.star} />
								{dayjs(reviewDetails?.createdDate).format("DD/MM/YYYY - HH:mm")}
							</div>
						</div>
					</div>
				</div>
				{/* <div className='mt-2 text-sm'>{t("Tên khoá học:", "Tên khoá học:")} {courseName}</div> */}
				{/* <div className='pt-1'>Đánh giá: */}
				<div className='feedback-txt mt-2'>{reviewDetails?.comment}</div>
				{/* </div> */}
				{reviewDetails?.feedback?.length > 0 || replyType === "feedback"
					? <>	<div className="hr-tag"></div>
						<div>{t("Phản hồi:", "Phản hồi:")}</div></> : null
				}

				{reviewDetails?.feedback?.length === 0 && replyType === "feedback" &&
					<>
						<TextArea
							autoSize={{ minRows: 3 }}
							placeholder={t("Nội dung phản hồi", "Nội dung phản hồi")}
							className='mt-2'
							onChange={(e) => setReplyContent(e.target.value)}
						/>
					</>
				}
				{reviewDetails?.feedback?.length > 0 &&
					reviewDetails?.feedback?.map((it: any) => {

						return <div key={it?.id}>
							<div className='flex align-center gap-4 mt-2'>
								<Avatar
									src={it?.imagePath}
									icon={<UserOutlined />}
									size={48}
								/>
								<div>
									<div className='flex align-center'>
										<p className='text-base'>{t("Giảng viên&nbsp;", "Giảng viên&nbsp;")}</p>
										<p className='text-lg font-weight-5'>{it?.username}</p>

									</div>
									<div className='flex align-center gap-8 description-color'>
										{dayjs(it?.createdDate).format("DD/MM/YYYY - HH:mm")}
									</div>
								</div>
							</div>
							<div className='pt-2 feedback-txt'>{it?.comment}</div>
						</div>
					})

				}

			</>
		</Modal>
	)
}

export default ReplyModal